import { InputV2 } from "@southfields-digital/mxmz-react-ui";
import classNames from "classnames";
import { useEffect, useState } from "react";

import { CardTypes } from "src/types/matchControl/card";

import styles from "../MatchControl.module.scss";
import type { MatchControlVariant } from "../types";

import AdjustButton from "./AdjustButton";

type CardsProps = {
	card: CardTypes;
	amount: number;
	variant?: MatchControlVariant;
	teamName?: string;
	handleChangeCards?: (card: CardTypes, amount: number) => void;
	handleChangeTeamName?: (name: string) => void;
};

const cardParagraphStyles: Record<CardTypes, string> = {
	[CardTypes.RED_CARD]: styles.RedCardParagraph,
	[CardTypes.GREEN_CARD]: styles.GreenCardParagraph,
	[CardTypes.YELLOW_CARD]: styles.YellowCardParagraph,
};

const Cards = ({
	card,
	amount,
	teamName,
	handleChangeTeamName,
	handleChangeCards,
	variant = "default",
}: CardsProps) => {
	const [localTeamName, setLocalTeamName] = useState(teamName ?? "");

	const handleTeamNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setLocalTeamName(e.target.value);
		handleChangeTeamName?.(e.target.value);
	};

	const handleAddCard = () => {
		if (!handleChangeCards) return;

		const newAmount = amount + 1;
		handleChangeCards(card, newAmount);
	};
	const handleSubtractCard = () => {
		if (!handleChangeCards) return;

		// Prevent negative card amounts
		const newAmount = Math.max(amount - 1, 0);
		handleChangeCards(card, newAmount);
	};

	useEffect(() => {
		setLocalTeamName(teamName ?? "");
	}, [teamName]);

	const isCompact = variant === "default";

	if (variant === "extended") {
		return (
			<div className="flex gap-4 flex-col">
				{teamName !== undefined && (
					<InputV2
						type="text"
						inputSize="lg"
						className="text-center text-lg w-9 min-w-0"
						value={localTeamName}
						onChange={handleTeamNameChange}
					/>
				)}

				<div className="flex gap-3 items-center">
					<AdjustButton isSquare onClick={handleSubtractCard} icon="minus" disabled={amount < 1} />
					<div className="flex items-center px-1 bg-danger rounded-sm">
						<p className={styles.CardParagraph}>{amount}</p>
					</div>
					<AdjustButton isSquare onClick={handleAddCard} icon="plus" />
				</div>
			</div>
		);
	}

	return (
		<div className="flex gap-2 flex-col">
			{teamName !== undefined && (
				<InputV2
					type="text"
					className={classNames("text-center min-w-0")}
					wrapperClassName={classNames(isCompact ? "max-w-[106px] self-center" : "w-9")}
					value={localTeamName}
					onChange={handleTeamNameChange}
				/>
			)}
			<div className={classNames("flex items-center", isCompact ? "gap-0" : "gap-3")}>
				<AdjustButton
					isSquare
					onClick={handleSubtractCard}
					icon="minus"
					disabled={amount < 1}
					isCompact={isCompact}
				/>
				<div className="flex items-center px-1 rounded-sm">
					<p className={cardParagraphStyles[card]}>{amount}</p>
				</div>
				<AdjustButton isSquare onClick={handleAddCard} icon="plus" isCompact={isCompact} />
			</div>
		</div>
	);
};

export default Cards;
